/**
 * Talia 52 kart — wspólna dla serwera i klienta.
 *
 * Stoi w `shared/`, a nie w `server/src/games/makao/`, bo ekran rysuje kartę
 * **kodem**: z figury i koloru składa prostokąt, tekst i symbol. Gdyby
 * parsowanie karty żyło tylko na serwerze, telefon miałby własną, drugą wersję
 * tego samego `split("-")` — i rozjechałaby się przy pierwszej zmianie
 * separatora.
 */
export const KOLORY = ["pik", "kier", "karo", "trefl"];
export const FIGURY = [
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "J",
    "Q",
    "K",
    "A",
];
/** Kier i karo rysujemy `--karta-czerwien`, pik i trefl `--karta-czern`. */
export const CZERWONE = ["kier", "karo"];
/**
 * Figury, których wolno zażądać waletem — **stała, niezależna od ustawień**.
 *
 * Żądanie waletów zapętla grę, żądanie asów zamienia ją w loterię kolorów.
 * Lista nie zmienia się nawet przy `damaNaWszystko`, bo zbiór legalnych żądań
 * zależny od ustawień rozjechałby telefon z serwerem: klient rysuje przyciski
 * z tej stałej, serwer waliduje tą samą.
 */
export const FIGURY_ZADANIA = ["5", "6", "7", "8", "9", "10"];
/**
 * Figury dopuszczalne jako karta startowa — ta sama lista i z tego samego
 * powodu. Karta startowa nie ma autora, więc nie ma komu przypisać jej efektu.
 */
export const FIGURY_STARTOWE = FIGURY_ZADANIA;
/** Wzorzec akceptowanej karty. Ten sam napis siedzi w `actionSchema` Makao. */
export const KARTA_RE = /^(?:[2-9]|10|[JQKA])-(?:pik|kier|karo|trefl)$/;
export function karta(figura, kolor) {
    return `${figura}-${kolor}`;
}
/**
 * Pełna talia w kolejności deterministycznej.
 *
 * Kolejność ma znaczenie wyłącznie dla testów — w grze pierwsze, co się z nią
 * dzieje, to `rng.shuffle` w `prepareAction`.
 */
export const PELNA_TALIA = KOLORY.flatMap((kolor) => FIGURY.map((figura) => karta(figura, kolor)));
export function figuraKarty(k) {
    return k.slice(0, k.indexOf("-"));
}
export function kolorKarty(k) {
    return k.slice(k.indexOf("-") + 1);
}
export function czyCzerwona(k) {
    return CZERWONE.includes(kolorKarty(k));
}
/**
 * Punkty karne za kartę zostawioną na ręce.
 *
 * Króle bojowe (K♠, K♥) są warte 25, pozostałe 10 — i **niezależnie od
 * ustawień partii**. Uzależnienie wartości od `kroleBojowe` znaczyłoby, że ta
 * sama karta w dwóch partiach liczy się inaczej, a fakt `karty_na_koncu`
 * przestałby być porównywalny między partiami.
 */
export function wartoscKarty(k) {
    const figura = figuraKarty(k);
    if (figura === "A")
        return 15;
    if (figura === "K")
        return czyKrolBojowy(k) ? 25 : 10;
    if (figura === "J" || figura === "Q")
        return 10;
    return Number(figura);
}
/** Suma punktów karnych ręki. Cała talia to 426 — patrz `makao.md`. */
export function wartoscReki(reka) {
    return reka.reduce((suma, k) => suma + wartoscKarty(k), 0);
}
/** Czy to król bojowy: pik bije w przód, kier w tył. */
export function czyKrolBojowy(k) {
    return figuraKarty(k) === "K" && (kolorKarty(k) === "pik" || kolorKarty(k) === "kier");
}
//# sourceMappingURL=karty.js.map